<div *ngIf="dashboardView!='charts'" class="p-grid" [ngClass]="{'dashboard-charts': opportunityReportsLoading && dashboardView!=''}">
    <div *ngIf="dashboardView==''" class="p-col-12">
        <app-filter [filterByInput]="cols" [filterByInputValue]="filterByInputValue"
            [customSeletedDateFilter]="selectedDateFilter"
            [showOpportunityChannelFilter]="showOpportunityChannelFilter" [opportunityChannelList]="opportunityChannelList" [selectedOpportunityChannel]="selectedOpportunityChannel" (onOpportunityChangeChannel)="onOpportunityChangeChannel($event)"
            [showChannelFilter]="showChannelFilter" [channelList]="channelList" [selectedChannel]="selectedChannel" (onChangeChannel)="onChangeChannel($event)"
            (onRemoveFilter)="onRemoveFilter(selectedWindow, $event)" (onClosePanel)="onClosePanel(selectedWindow)"
            (onApplyFilter)="onApplyFilter(selectedWindow, $event)"
            (onModifyFilterOptions)="onModifyFilterOptions(selectedWindow, $event)"
            (onChangeRange)="onChangeRange(selectedWindow, $event)">
        </app-filter>
    </div>

    <div *ngIf="(!opportunityReportsLoading && dashboardView!='') || dashboardView==''" class="p-col-12">
        <div class="card">
            <div class="main-content">
                <div id="divLeadsReport"
                *ngIf="selectedWindow == 'closedwonopportunitysummary'
                || selectedWindow == 'opportunityqualitymetricssummary'
                || selectedWindow == 'opportunityqualitymetricsdetail'
                || selectedWindow == 'opportunitypipelinesummary'
                || selectedWindow == 'opportunitypipelinedetail' ">
                    <app-table [reportType]="'simpleTB'" [reportName]="reportName" [reportDate]="reportDate"
                        [selectedWindow]="selectedWindow" [cols]="tableCols" [reportDatas]="reportsData" [showTitle]="dashboardView==''"></app-table>
                </div>
                <div id="divLeadsReport"
                *ngIf="selectedWindow == 'opportunitybycloseddatestagesummary' ">
                    <app-table [reportType]="'simpleTB'" [reportName]="reportName" [reportDate]="reportDate"
                        [selectedWindow]="selectedWindow" [cols]="tableCols" [reportDatas]="reportsData"
                        [chartLabel]="chartLabel" [chartType]="dashboardView==''?'simpleBar':''" [barData]="stageSummeryBar"
                        [basicOptions]="stageBarbasicOptions" [showTitle]="dashboardView==''"></app-table>
                </div>
                <div id="divLeadsReport" *ngIf="selectedWindow == 'closedwonopportunitydetail'">

                    <div *ngIf="dashboardView==''" class="p-grid p-mb-2" style="width: 100%; height: 100%;">
                        <div class="p-col-6">
                            <p-card>
                                <div class="p-d-flex" style="height: 100%">
                                    <p style="writing-mode: vertical-lr;transform: rotate(180deg);text-align: center;" class="p-mb-0">{{chartLabel}}</p>
                                    <div style="flex-grow:1; width:100%">
                                        <p-chart type="bar" height="200px" [data]="stackedBarByClosedWon" [options]="closedWonStackedOptions"></p-chart>
                                    </div>
                                </div>
                            </p-card>
                        </div>
                        <div class="p-col-6">
                            <p-card>
                                <div class="p-d-flex" style="height: 100%">
                                    <p style="writing-mode: vertical-lr;transform: rotate(180deg);text-align: center;" class="p-mb-0">{{chartLabel2}}</p>
                                    <div style="flex-grow:1; width:100%">
                                        <p-chart type="bar" height="200px" [data]="stackedBarByClosedWonCount" [options]="closedWonCountStackedOptions"></p-chart>
                                    </div>
                                </div>
                            </p-card>
                        </div>
                    </div>

                    <app-table [reportType]="'groupTSBFDataHeader'" [groupTypeColName]="groupByFieldName" [reportName]="reportName" [reportDate]="reportDate"
                        [selectedWindow]="selectedWindow" [cols]="tableCols" [reportDatas]="reportsData"
                        [showTitle]="dashboardView==''"></app-table>
                </div>

                <div id="divLeadsReport"
                *ngIf="selectedWindow == 'opportunitybycloseddatestagedetail' ">
                    <app-table [reportType]="'groupTSBFDataHeader'" [groupTypeColName]="groupByFieldName" [reportName]="reportName" [reportDate]="reportDate"
                        [selectedWindow]="selectedWindow" [cols]="tableCols" [reportDatas]="reportsData"
                        [chartLabel]="chartLabel" [chartType]="dashboardView==''?'stackedBar':''" [stackedBar]="stageDetailsBar"
                        [stackedOptions]="stageDetailsBarOptions" [showTitle]="dashboardView==''"></app-table>
                </div>

                <div id="divLeadsReport"
                *ngIf="selectedWindow == 'openopportunitybyowner' ">
                    <div *ngIf="dashboardView==''" class="p-grid">
                        <div class="p-col-12">
                            <div class="p-d-flex p-jc-between">
                                <h5 class="p-ml-3">{{reportName}}</h5>
                                <div>
                                    <span class="p-mr-3">{{reportDate | date: 'short'}}</span>
                                    <span class="btnBars" (click)="openSetting()">
                                        <i class="pi pi-cog"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <p-table [value]="openOpportunityOwnerdata" [columns]="tableCols" [(rows)]="showRows"
                    [showCurrentPageReport]="true" [paginator]="true" [(first)]="first"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                    styleClass="p-datatable-gridlines" [resizableColumns]="true">
                        <ng-template pTemplate="header" let-columns>
                            <tr>
                                <ng-container *ngFor="let col of columns">
                                    <th style="border-right: 1px solid var(--primary-color);" pResizableColumn>
                                        <span>{{col.header}}</span>
                                    </th>
                                </ng-container>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
                            <tr class="parentRow">
                                <td colspan="10">{{rowData.opportunityOwner}}</td>
                            </tr>
                            <tr *ngFor="let s of rowData.children">
                                <td *ngFor="let col of columns">

                                    <ng-container  [ngSwitch]="col?.dataType">
                                        <ng-container *ngSwitchCase="'datetime'">
                                            {{ s[col.field] | localDate }}
                                        </ng-container>
                                        <ng-container *ngSwitchCase="'date'">
                                            {{ s[col.field] | localDate:'date' }}
                                        </ng-container>
                                        <ng-container *ngSwitchCase="'timespan'">
                                            {{ s[col.field] | timeConvert }}
                                        </ng-container>
                                        <ng-container *ngSwitchCase="'number2dp'">
                                            {{ s[col.field] | number: '1.2-2' }}
                                        </ng-container>
                                        <ng-container *ngSwitchCase="'currencySymbol'">
                                            {{ s[col.field] | currencySymbol:'number2dp' }}
                                        </ng-container>
                                        <ng-container *ngSwitchCase="'percentageSymbol'">
                                            {{ s[col.field] | percentageSymbol }}
                                        </ng-container>
                                        <ng-container *ngSwitchDefault>
                                            {{ s[col.field] }}
                                       </ng-container>
                                    </ng-container>
                                </td>
                            </tr>
                            <tr>
                                <td></td>
                                <td colspan="3" class="p-text-center">Sales Person Total: </td>
                                <td>{{rowData.netRevenue | currencySymbol:'number2dp' }}</td>
                                <td>{{rowData.netAmount | currencySymbol:'number2dp' }}</td>
                                <td colspan="2" class="p-text-center">Avg. Days in Pipeline: </td>
                                <td>{{rowData.avgDays}}</td>
                            </tr>
                            <tr class="parentRow" *ngIf="rowIndex == openOpportunityOwnerdata.length - 1">
                                <td colspan="4" class="p-text-center">Grand  Total: </td>
                                <td>{{totalRevenue | currencySymbol:'number2dp' }}</td>
                                <td colspan="5">{{totalAmount | currencySymbol:'number2dp' }}</td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                            <tr>
                                <td colspan="18">{{noData}}</td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>

                <div id="divLeadsReport"
                *ngIf="selectedWindow == 'winlosssalesanalysis' ">
                    <div *ngIf="dashboardView==''" class="p-grid">
                        <div class="p-col-12">
                            <div class="p-d-flex p-jc-between">
                                <h5 class="p-ml-3">{{reportName}}</h5>
                                <div>
                                    <span class="p-mr-3">{{reportDate | date: 'short'}}</span>
                                    <span class="btnBars" (click)="openSetting()">
                                        <i class="pi pi-cog"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="dashboardView==''" class="p-grid">
                        <div class="p-col-12 p-md-6">
                            <p-card>
                                <div class="p-d-flex">
                                    <p style="writing-mode: vertical-lr;transform: rotate(180deg);text-align: center;" class="p-mb-0">{{chartLabel1}}</p>
                                    <div style="flex-grow:1; width:100%">
                                        <p-chart type="bar" height="200px" [data]="performanceStackBarAmount" [options]="stackedOptions1"></p-chart>
                                    </div>
                                </div>
                            </p-card>
                        </div>
                        <div class="p-col-12 p-md-6">
                            <p-card>
                                <div class="p-d-flex">
                                    <p style="writing-mode: vertical-lr;transform: rotate(180deg);text-align: center;" class="p-mb-0">{{chartLabel2}}</p>
                                    <div style="flex-grow:1; width:100%">
                                        <p-chart type="bar" height="200px" [data]="performanceStackBarPercentage" [options]="stackedOptions2"></p-chart>
                                    </div>
                                </div>
                            </p-card>
                        </div>
                    </div>

                    <p-table [value]="reportsData" [columns]="cols" [(rows)]="showRows"
                    [showCurrentPageReport]="true" [paginator]="true" [(first)]="first"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                    styleClass="p-datatable-gridlines" [resizableColumns]="true">
                        <ng-template pTemplate="header" let-columns>
                            <tr>
                                <ng-container *ngFor="let col of columns">
                                    <th style="border-right: 1px solid var(--primary-color);" pResizableColumn>
                                        <span>{{col.header}}</span>
                                    </th>
                                </ng-container>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
                            <tr class="parentRow">
                                <td colspan="3">{{rowData.salesPerson}}</td>
                                <td>{{rowData.wonPerc | percentageSymbol}}</td>
                                <td>{{rowData.lostPerc | percentageSymbol}}</td>
                                <td colspan="2"></td>
                            </tr>
                            <tr *ngFor="let s of rowData.status">
                                <td *ngFor="let col of columns">
                                    <ng-container  [ngSwitch]="col?.dataType">
                                        <ng-container *ngSwitchCase="'datetime'">
                                            {{ s[col.field] | localDate }}
                                        </ng-container>
                                        <ng-container *ngSwitchCase="'date'">
                                            {{ s[col.field] | localDate:'date' }}
                                        </ng-container>
                                        <ng-container *ngSwitchCase="'timespan'">
                                            {{ s[col.field] | timeConvert }}
                                        </ng-container>
                                        <ng-container *ngSwitchCase="'number2dp'">
                                            {{ s[col.field] | number: '1.2-2' }}
                                        </ng-container>
                                        <ng-container *ngSwitchCase="'currencySymbol'">
                                            {{ s[col.field] | currencySymbol:'number2dp' }}
                                        </ng-container>
                                        <ng-container *ngSwitchDefault>
                                            {{ s[col.field] }}
                                       </ng-container>
                                    </ng-container>
                                </td>
                            </tr>
                            <tr class="amountRow">
                                <td></td>
                                <td colspan="2" class="p-text-center">Sales Person Total: </td>
                                <td>{{rowData.totalWon}}</td>
                                <td>{{rowData.totalLost}}</td>
                                <td>{{rowData.totalOpen}}</td>
                                <td>{{rowData.totalAll}}</td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                            <tr>
                                <td colspan="18">{{noData}}</td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>


            </div>
        </div>
    </div>

    <div *ngIf="opportunityReportsLoading && dashboardView!=''" class="p-col-12">
        <div class="dashboard-charts p-d-flex">
            <app-block-content-spinner  height="100%" style="width: 100%"></app-block-content-spinner>
        </div>
    </div>
</div>

<app-filter *ngIf="dashboardView!=''"  [filterByInput]="cols" [filterByInputValue]="filterByInputValue"
    [customSeletedDateFilter]="selectedDateFilter"
    [showOpportunityChannelFilter]="showOpportunityChannelFilter" [opportunityChannelList]="opportunityChannelList" [selectedOpportunityChannel]="selectedOpportunityChannel" (onOpportunityChangeChannel)="onOpportunityChangeChannel($event)"
    [showChannelFilter]="showChannelFilter" [channelList]="channelList" [selectedChannel]="selectedChannel" (onChangeChannel)="onChangeChannel($event)"
    (onRemoveFilter)="onRemoveFilter(selectedWindow, $event)" (onClosePanel)="onClosePanel(selectedWindow)"
    (onApplyFilter)="onApplyFilter(selectedWindow, $event)"
    (onModifyFilterOptions)="onModifyFilterOptions(selectedWindow, $event)"
    (onChangeRange)="onChangeRange(selectedWindow, $event)"
    [filterPopupOnly]="true" [displayFilterPopup]="displayFilterPopup"
    (onCloseFilterPopup)="closeFilterPopup()"
    (onAllFilterApply)="allFiltersChanges($event)">
</app-filter>


<div *ngIf="dashboardView=='charts'" class="dashboard-charts p-d-flex">
    <ng-container *ngIf="!opportunityReportsLoading" [ngSwitch]="selectedWindow">
        <ng-container *ngSwitchCase="'closedwonopportunitydetail'">
                <div class="p-grid" style=" width: 100%; height: 100%;">
                    <div class="p-col-6">
                        <div class="p-d-flex" style="height: 100%;">
                            <p style="writing-mode: vertical-lr;transform: rotate(180deg);text-align: center;" class="p-mb-0">{{chartLabel}}</p>
                            <div style="flex-grow:1; width:100%">
                                <p-chart type="bar" height="100%" [data]="stackedBarByClosedWon" [options]="closedWonStackedOptions"></p-chart>
                            </div>
                        </div>
                    </div>
                    <div class="p-col-6">
                        <div class="p-d-flex" style="height: 100%;">
                            <p style="writing-mode: vertical-lr;transform: rotate(180deg);text-align: center;" class="p-mb-0">{{chartLabel2}}</p>
                            <div style="flex-grow:1; width:100%">
                                <p-chart type="bar" height="100%" [data]="stackedBarByClosedWonCount" [options]="closedWonCountStackedOptions"></p-chart>
                            </div>
                        </div>
                    </div>
                </div>
        </ng-container>
        <ng-container *ngSwitchCase="'opportunitybycloseddatestagesummary'">
            <p style="writing-mode: vertical-lr;transform: rotate(180deg);text-align: center;" class="p-mb-0">{{chartLabel}}</p>
            <div style="flex-grow:1; width:100%">
                <p-chart type="bar" height="100%" [data]="stageSummeryBar" [options]="stageBarbasicOptions"></p-chart>
            </div>
        </ng-container>
        <ng-container *ngSwitchCase="'opportunitybycloseddatestagedetail'">
            <p style="writing-mode: vertical-lr;transform: rotate(180deg);text-align: center;" class="p-mb-0">{{chartLabel}}</p>
            <div style="flex-grow:1; width:100%">
                <p-chart type="bar" height="100%" [data]="stageDetailsBar" [options]="stageDetailsBarOptions"></p-chart>
            </div>
        </ng-container>
        <ng-container *ngSwitchCase="'winlosssalesanalysis'">
            <div class="p-grid" style=" width: 100%; height: 100%;">
                <div class="p-col-6">
                    <div class="p-d-flex" style="height: 100%;">
                        <p style="writing-mode: vertical-lr;transform: rotate(180deg);text-align: center;" class="p-mb-0">{{chartLabel1}}</p>
                        <div style="flex-grow:1; width:100%">
                            <p-chart type="bar" height="100%" [data]="performanceStackBarAmount" [options]="stackedOptions1"></p-chart>
                        </div>
                    </div>
                </div>
                <div class="p-col-6">
                    <div class="p-d-flex" style="height: 100%;">
                        <p style="writing-mode: vertical-lr;transform: rotate(180deg);text-align: center;" class="p-mb-0">{{chartLabel2}}</p>
                        <div style="flex-grow:1; width:100%">
                            <p-chart type="bar" height="100%" [data]="performanceStackBarPercentage" [options]="stackedOptions2"></p-chart>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
    </ng-container>
    <app-block-content-spinner *ngIf="opportunityReportsLoading" height="100%" style="width: 100%"></app-block-content-spinner>
</div>
